export function buildFormData<T extends Record<string, any>>(formData: FormData, data: T, parentKey?: string, stringifyKeys: Set<string> = new Set()): void {
    if (data && typeof data === 'object' && !(data instanceof File) && !(data instanceof Blob) && !(Array.isArray(data) && (data[0] instanceof File || data[0] instanceof Blob))) {
        Object.keys(data).forEach((key): void => {
            const value = data[key as keyof T];
            if (stringifyKeys.has(key)) {
                formData.append(parentKey ? `${parentKey}[${key}]` : key, JSON.stringify(value as any));
            } else {
                buildFormData(formData, value, parentKey ? `${parentKey}[${key}]` : key, stringifyKeys);
            }
        });
    } else {
        const value = data == null ? '' : data;
        formData.append(parentKey || '', value as any);
    }
}

export function jsonToFormData<T extends Record<string, any>>(data: T, stringifyKeys: string[] = []): FormData {
    const formData: FormData = new FormData();
    buildFormData(formData, data, undefined, new Set(stringifyKeys));
    return formData;
}
